import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({ standalone: true, name: 'fnCall' })
export class FnCallPipe implements PipeTransform {
  public transform<U extends () => any>(fn: U): ReturnType<U>;
  public transform<U extends (arg: T) => any, T>(fn: U, arg: T): ReturnType<U>;
  public transform<U extends (arg1: T, arg2: X) => any, T, X>(
    fn: U,
    arg1: T,
    arg2: X,
  ): ReturnType<U>;
  public transform<U extends (arg1: T, arg2: X, arg3: Y) => any, T, X, Y>(
    fn: U,
    arg1: T,
    arg2: X,
    arg3: Y,
  ): ReturnType<U>;
  public transform<U extends (arg1: T, arg2: X, arg3: Y, arg4: Z) => any, T, X, Y, Z>(
    fn: U,
    arg1: T,
    arg2: X,
    arg3: Y,
    arg4: Z,
  ): ReturnType<U>;
  public transform<const U extends (...args: T[]) => any, T>(fn: U, ...args: T[]): ReturnType<U> {
    return fn(...args);
  }
}
